import React, { Fragment, useEffect, useState } from "react";
import {
  Button,
  Col,
  Dropdown,
  Form,
  Modal,
  Row,
  Table,
} from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import * as apicall from "../../components/Apicall";
import AddOfferings from "./AddOfferings";
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";
import { MultiSelect } from "primereact/multiselect";
import AddService from "./AddService";
import Loader from "../../components/Loader/Loader";
import EachAddOffering from "./EachAddOffering";
import { MdModeEdit } from "react-icons/md";
import RotateDevicePopup from "../../components/RotateDevicePopup/RotateDevicePopup";
import ShowAdminView from "./ShowAdminView";

function AdminSetup() {
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(0);

  const [allServices, setAllServices] = useState([]);
  const [partners, setPartners] = useState([]);
  const [initialServiceData, setInitialServiceData] = useState([]);
  const [serviceData, setServiceData] = useState([]);
  const columns = [
    "service_name",
    "partner_name",
    "service_type_name",
    "service_offering_name",
    "price",
  ];
  const [showAddOffering, setShowAddOffering] = useState(false);
  const [showAddService, setShowAddService] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [profle_name, setProfile_name] = useState("");
  const [error, setError] = useState("");

  const [addOffering, setAddOffering] = useState([
    {
      service_id: 0,
      service_name: "",
      service_type_id: 0,
      service_type_name: "",
      service_offering_id: 0,
      service_offering_name: "",
      partner_id: 0,
      partner_name: "",
      amount: 0,
      time_required: 30,
      buffer: 0,
    },
  ]);
  const [allService, setAllService] = useState([]);
  const [allType, setAllType] = useState([]);
  const [allOffering, setAllOffering] = useState([]);
  const [allPartner, setAllPartner] = useState([]);
  const [selectedService, setSelectedService] = useState([]);
  const [selectedType, setSelectedType] = useState([]);
  const [selectedOffering, setSelectedOffering] = useState([]);
  const [selectedPartner, setSelectedPartner] = useState([]);

  const [curretOffering, setCurrentOffering] = useState({});
  const [updateModel, setUpdateModel] = useState(false);
  const [deleteModel, setDeleteModel] = useState(false);
  const [selectedView, setSelectedView] = useState([
    { id: 1, name: "View Services" },
    { id: 2, name: "View Profile" },
  ]);
  const optionsViewAll = [
    { id: 1, name: "View Services" },
    { id: 2, name: "View Profile" },
  ];

  console.log(allPartner, allService);

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchData();
    }, 500);
    return () => clearTimeout(timer);
  }, [
    page,
    limit,
    selectedService,
    selectedType,
    selectedOffering,
    selectedPartner,
  ]);

  useEffect(() => {
    getAllServices();
  }, []);

  useEffect(() => {
    getServiceType();
  }, [selectedService]);

  useEffect(() => {
    getServiceOffering();
  }, [selectedType]);

  async function uniqueValue(data) {
    try {
      // console.log("data---", data);
      let d1 = [];
      for (let eachData of Object.keys(data || {})) {
        if (eachData !== "null" && eachData) {
          d1?.push({
            id: eachData,
            name: data[eachData],
          });
        }
      }
      return d1;
    } catch (e) {
      console.log("err----", e);
    } finally {
    }
  }

  async function fetchData() {
    try {
      setLoading(true);
      // console.log("selectedService---", selectedService);
      let s1 = selectedService?.map((ele) => Number(ele?.id));
      let s2 = selectedType?.map((ele) => Number(ele?.id));
      let s3 = selectedOffering?.map((ele) => Number(ele?.id));
      let s4 = selectedPartner?.map((ele) => Number(ele?.id));

      const response = await apicall.get(
        `offeringFromService?selectedService=${s1}&&selectedType=${s2}&&selectedOffering=${s3}&&selectedPartner=${s4}&&page=${page}&&limit=${limit}`
      );
      setLoading(false);
      if (response.success && response.data) {
        setInitialServiceData(response.data);
        setServiceData(response.data);

        setTotalPages(response.pagination?.total_pages || 0);

        // let { services, service_types, service_offerings } =
        //   response?.uniqueValues;

        // let [service, serviceType, serviceOffering] = await Promise.all([
        //   uniqueValue(services),
        //   uniqueValue(service_types),
        //   uniqueValue(service_offerings),
        // ]);
        // setAllService(service);
        // setAllType(serviceType);
        // setAllOffering(serviceOffering);
      } else {
        setInitialServiceData([]);
        setServiceData([]);
      }
    } catch (e) {
      console.log("e----", e);
    } finally {
      setLoading(false);
    }
  }

  async function getAllServices() {
    try {
      setLoading(true);

      let [services_api, service_type_api, service_offering_api, partners_api] =
        await Promise.all([
          apicall.get(`get_ezp_service`),
          apicall.get(`get_ezp_service_types`),
          apicall.get(`get_ezp_service_offerings`),
          apicall.get(`partners`),
        ]);
      if (services_api.success && services_api.data) {
        setAllServices(services_api.data);
        setAllService(
          services_api.data?.map((ele) => {
            return { id: ele.id, name: ele.name };
          })
        );
        setAllType(service_type_api.data);
        setAllOffering(service_offering_api.data);
      } else {
        setAllServices([]);
        setAllType([]);
        setAllOffering([]);
      }

      if (partners_api.success && partners_api.data) {
        setPartners(partners_api.data);
        let p1 = partners_api?.data?.map((ele) => ({
          id: ele.id,
          name: ele.partner_name,
        }));
        setAllPartner(p1);
      } else {
        setPartners([]);
      }

      setLoading(false);
    } catch (e) {
      console.log("e----", e);
    } finally {
      setLoading(false);
    }
  }

  async function getServiceType() {
    try {
      setLoading(true);

      let q1 = `get_ezp_service_types`;
      let q2 = `get_ezp_service_offerings`;

      let s1 = selectedService?.map((ele) => ele?.id);

      if (s1?.length > 0) {
        q1 += `?services=${s1}`;
        q2 += `?services=${s1}`;
      }

      let [service_type_api, service_offering_api] = await Promise.all([
        apicall.get(q1),
        apicall.get(q2),
      ]);
      setAllType(service_type_api.data);
      setAllOffering(service_offering_api.data);

      setLoading(false);
    } catch (e) {
      console.log("e----", e);
    } finally {
      setLoading(false);
    }
  }

  async function getServiceOffering() {
    try {
      setLoading(true);
      let q = `get_ezp_service_offerings`;
      let s1 = selectedService?.map((ele) => ele?.id);
      let t1 = selectedType?.map((ele) => ele?.id);
      let flag = true;
      if (s1?.length > 0) {
        q += `?services=${s1}`;
        flag = false;
      }
      if (t1?.length > 0) {
        if (flag) {
          q += `?service_type=${t1}`;
        } else {
          q += `&&service_type=${t1}`;
        }
      }

      console.log("query----", q);

      let [service_offering_api] = await Promise.all([apicall.get(q)]);

      setAllOffering(service_offering_api.data);

      setLoading(false);
    } catch (e) {
      console.log("e----", e);
    } finally {
      setLoading(false);
    }
  }

  console.log("allServices------", allServices);

  const onHideService = (data) => {
    setShowAddService(false);
    if (data) {
      getAllServices();
    }
  };

  const onHide = () => {
    setShowAddOffering(false);
    setAddOffering([
      {
        service_id: 0,
        service_name: "",
        service_type_id: 0,
        service_type_name: "",
        service_offering_id: 0,
        service_offering_name: "",
        partner_id: 0,
        partner_name: "",

        amount: 0,
        time_required: 0,
        buffer: null,
      },
    ]);
  };

  //   const addMore = () => {
  //       if (!addOffering.length) return;

  //     let copyAddOffering = JSON.parse(JSON.stringify(addOffering));
  // console.log(copyAddOffering,"copyAddOffering")
  //     let newOffer = addOffering[copyAddOffering.length - 1];
  //     console.log(newOffer,"newOffer")

  //     newOffer.service_offering_name = "";

  //     // let newOffer = {
  //     //   service_id: 0,
  //     //   service_name: "",
  //     //   service_type_id: 0,
  //     //   service_type_name: "",
  //     //   service_offering_id: 0,
  //     //   service_offering_name: "",
  //     //   partner_id: 0,
  //     //   partner_name: "",
  //     //   amount: 0,
  //     //   time_required: 30,
  //     //   buffer: 0,
  //     // };

  //     // let items = [...addOffering, newOffer];

  //     copyAddOffering.push(newOffer);
  //     setAddOffering(copyAddOffering);
  //   };

  const addMore = () => {
    let newOffer;

    if (addOffering.length === 0) {
      // If no rows exist, create first default row
      newOffer = {
        service_id: "",
        service_name: "",
        service_type_id: "",
        service_type_name: "",
        service_offering_id: 0,
        service_offering_name: "",
        partner_id: 0,
        partner_name: "",
        amount: "",
        time_required: 30,
        buffer: "",
      };
    } else {
      const lastItem = addOffering[addOffering.length - 1];

      newOffer = {
        ...lastItem, // clone previous row
        service_offering_id: 0, // reset only required fields
        service_offering_name: "",
        amount: "",
        time_required: 30,
        buffer: "",
      };
    }

    setAddOffering((prev) => [...prev, newOffer]);
  };

  const removeOffering = (index) => {
    console.log("index---", index);
    let removeddata = addOffering.filter((ele, idx) => index !== idx);
    setAddOffering(removeddata);
  };

  // const totalPages = Math.ceil(totalCount / limit);
  const getPageNumbers = () => {
    const pageNumbers = [];
    const totalPagesToShow = 5;
    const halfWay = Math.floor(totalPagesToShow / 2);

    if (totalPages <= totalPagesToShow) {
      // If total pages are less than or equal to totalPagesToShow, show all pages
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      // Always show first page
      pageNumbers.push(1);

      let startPage = Math.max(2, page - halfWay);
      let endPage = Math.min(totalPages - 1, page + halfWay);

      // Adjust start and end if we're near the beginning or end
      if (page <= halfWay + 1) {
        endPage = totalPagesToShow - 1;
      } else if (page >= totalPages - halfWay) {
        startPage = totalPages - totalPagesToShow + 2;
      }

      // Add ellipsis after first page if needed
      if (startPage > 2) {
        pageNumbers.push("...");
      }

      // Add middle pages
      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
      }

      // Add ellipsis before last page if needed
      if (endPage < totalPages - 1) {
        pageNumbers.push("...");
      }

      // Always show last page
      pageNumbers.push(totalPages);
    }

    return pageNumbers;
  };

  const updateData = ({ index, copyData }) => {
    try {
      let offerings = [...addOffering];
      offerings[index] = copyData;
      setAddOffering(offerings);
    } catch (e) {
      console.log("errr---", e);
    }
  };
  // const updateData = ({ index, copyData }) => {
  //   let updated = [...addOffering];   // ✅ use state

  //   updated[index] = copyData;

  //   // clear all errors first
  //   updated = updated.map((item) => ({
  //     ...item,
  //     error: {}
  //   }));

  //   // duplicate validation
  //   updated.forEach((item, i) => {
  //     updated.forEach((x, j) => {

  //       // Duplicate Offering
  //       if (
  //         i !== j &&
  //         item.service_id === x.service_id &&
  //         item.service_offering_name?.toLowerCase()?.trim() ===
  //         x.service_offering_name?.toLowerCase()?.trim()
  //       ) {
  //         item.error.service_offering_name_error =
  //           "Same Offering not allowed for this Service";
  //         x.error.service_offering_name_error =
  //           "Same Offering not allowed for this Service";
  //       }

  //       // Duplicate Custom Type
  //       if (
  //         item.service_type_name === "Custom" &&
  //         x.service_type_name === "Custom" &&
  //         i !== j &&
  //         item.custom_type_name?.toLowerCase()?.trim() ===
  //         x.custom_type_name?.toLowerCase()?.trim()
  //       ) {
  //         item.error.custom_type_name_error =
  //           "Same Custom Type not allowed for this Service";
  //         x.error.custom_type_name_error =
  //           "Same Custom Type not allowed for this Service";
  //       }

  //     });
  //   });

  //   setAddOffering(updated);   // ✅ correct setter
  // };
  const updateOfferingData = (data) => {
    try {
      console.log("copydaata-updateOfferingData--", data);
      let copyData = JSON.parse(JSON.stringify(data));
      setCurrentOffering(copyData);
    } catch (e) {
      console.log("errr---", e);
    }
  };

  const addOfferingSumbit = async () => {
    try {
      // console.log("add---", addOffering);
      // setLoading(true);
      let flag = true;

      for (let i of addOffering) {
        if (Object.keys(i?.error).length > 0) {
          return;
        }
      }

      let copyaddOffering = JSON.parse(JSON.stringify(addOffering));

      for (let eachOffering of copyaddOffering) {
        let requiredFields = [
          "service_name",
          "service_type_name",
          "service_offering_name",
          "partner_name",
          "amount",
          "time_required",
          "buffer",
          "custom_type_name",
        ];
        for (let field of requiredFields) {
          if (field === "custom_type_name" && eachOffering[field]) {
            if (!eachOffering["custom_type_name"]) {
              let errorText = field
                .replaceAll("_", " ")
                .split(" ")
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ");

              if (!eachOffering["error"]) eachOffering["error"] = {};
              if (!eachOffering["error"][`${field}_error`])
                eachOffering["error"][`${field}_error`] = "";
              eachOffering["error"][`${field}_error`] = `Fill ${errorText}`;
              flag = false;
            }
          } else {
            if (
              (eachOffering[field] === undefined ||
                eachOffering[field] === null ||
                eachOffering[field] === "") &&
              field !== "custom_type_name"
            ) {
              if (
                field === "service_type_name" &&
                !eachOffering["service_type"]
              ) {
                continue;
              } else {
                let errorText = field
                  .replaceAll("_", " ")
                  .split(" ")
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(" ");
                if (!eachOffering["error"]) eachOffering["error"] = {};
                if (!eachOffering["error"][`${field}_error`])
                  eachOffering["error"][`${field}_error`] = "";
                eachOffering["error"][`${field}_error`] = `Fill ${errorText}`;
                flag = false;
              }
            }
          }
        }
      }

      setAddOffering(copyaddOffering);
      if (!flag) return;
      const response = await apicall.post(copyaddOffering, "add_items");
      fetchData();
      setLoading(false);
      setLoading(false);
      setShowAddOffering(false);
      setAddOffering([
        {
          service_id: 0,
          service_name: "",
          service_type_id: 0,
          service_type_name: "",
          service_offering_id: 0,
          service_offering_name: "",
          partner_id: 0,
          partner_name: "",
          amount: 0,
          time_required: 0,
          buffer: null,
        },
      ]);
    } catch (e) {
      console.log("err---", e);
    } finally {
    }
  };

  const deleteOffering = async () => {
    try {
      setLoading(true);
      const response = await apicall.post(curretOffering, "delete_offering");
      console.log("response----", response);
      fetchData();
      setLoading(false);
      setCurrentOffering({});
    } catch (e) {
      console.log("err---", e);
    } finally {
      setLoading(false);
      setDeleteModel(false);
      setCurrentOffering({});
      fetchData();
    }
  };

  const updateOffering = async () => {
    try {
      let flag = true;
      let copyCurretOffering = JSON.parse(JSON.stringify(curretOffering));

      let eachOffering = copyCurretOffering;
      let requiredFields = [
        "service_name",
        "service_type_name",
        "service_offering_name",
        "partner_name",
        "amount",
        "time_required",
        "buffer",
      ];
      for (let field of requiredFields) {
        if (field === "custom_type_name" && eachOffering[field]) {
          if (!eachOffering["custom_type_name"]) {
            let errorText = field
              .replaceAll("_", " ")
              .split(" ")
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" ");

            if (!eachOffering["error"]) eachOffering["error"] = {};
            if (!eachOffering["error"][`${field}_error`])
              eachOffering["error"][`${field}_error`] = "";
            eachOffering["error"][`${field}_error`] = `Fill ${errorText}`;
            flag = false;
          }
        } else {
          if (
            (eachOffering[field] === undefined ||
              eachOffering[field] === null ||
              eachOffering[field] === "") &&
            field !== "custom_type_name"
          ) {
            if (
              field === "service_type_name" &&
              !eachOffering["service_type"]
            ) {
              console.log("eachOffering----", eachOffering);
              continue;
            } else {
              let errorText = field
                .replaceAll("_", " ")
                .split(" ")
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ");
              if (!eachOffering["error"]) eachOffering["error"] = {};
              if (!eachOffering["error"][`${field}_error`])
                eachOffering["error"][`${field}_error`] = "";
              eachOffering["error"][`${field}_error`] = `Fill ${errorText}`;
              flag = false;
            }
          }
        }
      }

      console.log("copyaddOffering0--update......---", eachOffering, flag);
      setCurrentOffering(eachOffering);
      if (!flag) return;

      // console.log("lets ,,,,....gooooo");
      setLoading(true);
      const response = await apicall.post(curretOffering, "update_offering");
      console.log("response----", response);
      fetchData();
      setUpdateModel(false);
      setCurrentOffering({});
    } catch (e) {
      console.log("err---", e);
    } finally {
      setLoading(false);
    }
  };

  const clearAll = () => {
    setPage(1);
    setSelectedService([]);
    setSelectedType([]);
    setSelectedOffering([]);
    setSelectedPartner([]);
  };

  const addProfile = async () => {
    try {
      if (!profle_name || profle_name.trim() === "") {
        setError("Profile name is required");
        return;
      }

      let data = {
        profile_name: profle_name,
      };
      const response = await apicall.post(data, "add_profile");
      console.log("response----", response);
      setProfile_name("");
      await getAllServices();
    } catch (e) {
      console.log("err---", e);
    } finally {
      setShowProfile(false);
    }
  };

  let s1 = allService?.map((ele) => ele?.name);
  let p1 = allPartner?.map((ele) => ele?.name);

  async function refreshPage() {
    fetchData();
    getAllServices();
    getServiceType();
    getServiceOffering();
  }

  console.log("selectedView----", selectedView);

  return (
    <>
      <RotateDevicePopup />
      <div className="container-fluid px-3">
        <div className="d-flex">
          {/* <div className="rounded cursor-pointer btn-danger p-2 py-1 mb-2">
          Clear All
        </div> */}
        </div>
        <div
          className={`d-flex align-items-start flex-wrap mb-4 justify-content-end`}
        >
          <divc className="d-flex gap-2 mobile-top-actions">
            <MultiSelect
              value={selectedView}
              onChange={(e) => {
                setSelectedView(e.value);
              }}
              options={optionsViewAll}
              optionLabel="name"
              filter
              filterDelay={400}
              placeholder="̉View"
              maxSelectedLabels={3}
              className="viewBtn"
              // style={{ width: "100%", height: "40px" }}
            />

            <Dropdown>
              <Dropdown.Toggle
                className="btn-danger border-radius-16px "
                variant="danger"
              >
                + Add New |{" "}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item onClick={() => setShowAddService(true)}>
                  Add Service
                </Dropdown.Item>

                <Dropdown.Item onClick={() => setShowAddOffering(true)}>
                  Add Service Type
                </Dropdown.Item>

                <Dropdown.Item onClick={() => setShowProfile(true)}>
                  Add Profile
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            {/* <div className="d-flex gap-3 flex-wrap mobile-btn-row">
            <div
              onClick={() => setShowAddService(true)}
              // className="cursor-pointer rounded btn-larges btn p-2 px-4 "
              className="cursor-pointer rounded btn-danger p-2 px-4 "
            >
              Add Service
            </div>
            <div
              onClick={() => setShowAddOffering(true)}
              className="cursor-pointer rounded btn-danger p-2 px-4 "
            >
              Add Type
            </div>
            <div
              onClick={() => setShowProfile(true)}
              // className="cursor-pointer rounded btn-larges btn p-2 px-4 "
              className="cursor-pointer rounded btn-danger p-2 px-4 "
            >
              Add Profile
            </div>
          </div> */}
          </divc>
        </div>

        <div className="d-flex justify-content-between align-items-center flex-wrap mb-4">
          <div
            style={{ width: "1000%" }}
            className="d-flex align-items-center gap-3 flex-wrap"
          >
            <div
              style={{ width: "85%" }}
              className="d-flex align-items-center mb-2 gap-2 mobile-dropdown-grid"
            >
              <MultiSelect
                value={selectedService}
                onChange={(e) => {
                  setPage(1);
                  setSelectedService(e.value);
                }}
                options={allService}
                optionLabel="name"
                filter
                filterDelay={400}
                placeholder="Service Category"
                maxSelectedLabels={3}
                // className="form-control "
                style={{ width: "100%", height: "40px" }}
              />

              <MultiSelect
                value={selectedType}
                onChange={(e) => {
                  setPage(1);
                  setSelectedType(e.value);
                }}
                options={allType}
                optionLabel="name"
                filter
                filterDelay={400}
                placeholder="Sub Category"
                maxSelectedLabels={3}
                // className="form-control "
                style={{ width: "100%", height: "40px" }}
              />

              <MultiSelect
                value={selectedOffering}
                onChange={(e) => {
                  setPage(1);
                  setSelectedOffering(e.value);
                }}
                options={allOffering}
                optionLabel="name"
                filter
                filterDelay={400}
                placeholder="Service Type"
                maxSelectedLabels={3}
                // className="form-control "
                style={{ width: "100%", height: "40px" }}
              />

              <MultiSelect
                value={selectedPartner}
                onChange={(e) => {
                  setPage(1);
                  setSelectedPartner(e.value);
                }}
                options={allPartner}
                optionLabel="name"
                filter
                filterDelay={400}
                placeholder="Profile"
                maxSelectedLabels={3}
                // className="form-control "
                style={{ width: "100%", height: "40px" }}
              />
            </div>
            <div className="clearAll" onClick={() => clearAll()}>
              Clear All
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2">
          <div className="table-responsive">
            <Table
              bordered
              hover
              className="align-middle mb-0 bg-custom-light border-custom custom-table"
              style={{ fontSize: "14px" }}
            >
              <thead>
                <tr className="table-header-row">
                  <th>Sl. No</th>
                  <th>Service Category</th>
                  <th>Profile</th>
                  <th>Sub Category</th>
                  <th>Service Type</th>
                  <th>Price</th>
                  <th>Edit</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  Array(10)
                    .fill(null)
                    .map((_, index) => (
                      <tr key={index}>
                        <td>
                          <Skeleton width="30px" />
                        </td>
                        <td>
                          <Skeleton width="150px" />
                        </td>
                        <td>
                          <Skeleton width="120px" />
                        </td>
                        <td>
                          <Skeleton width="80px" />
                        </td>
                        <td>
                          <Skeleton width="100px" />
                        </td>
                        <td>
                          <Skeleton width="80px" />
                        </td>
                        <td>
                          <div className="d-flex gap-3">
                            <Skeleton width="80px" />
                            <Skeleton width="80px" />
                          </div>
                        </td>
                      </tr>
                    ))
                ) : (
                  <Fragment>
                    {serviceData?.map((data, index) => {
                      return (
                        <tr key={data?.service_offering_id || index}>
                          <td>{(page - 1) * limit + index + 1}</td>
                          {columns?.map((col, idx) => (
                            <td key={idx}>{data[col]}</td>
                          ))}
                          <td
                            onClick={() => {
                              setCurrentOffering(data);
                              setUpdateModel(true);
                            }}
                            className="cursor-pointer"
                          >
                            <MdModeEdit />
                          </td>
                          <td>
                            <span
                              onClick={() => {
                                setCurrentOffering(data);
                                setDeleteModel(true);
                              }}
                              className="btn-danger rounded px-2 py-1 cursor-pointer"
                            >
                              Delete
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </Fragment>
                )}
              </tbody>
            </Table>
          </div>
        </div>

        {/* Pagination */}
        <div className="pagination-wrapper mt-4">
          <div className="d-flex align-items-center gap-2">
            <button
              className="btn bg-white text-black btn-outline-borders d-flex align-items-center px-2"
              style={{ height: "32px", fontSize: "14px", minWidth: "32px" }}
              onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
              disabled={page === 1}
            >
              <FaArrowLeft /> Prev
            </button>

            <div className="d-flex">
              {getPageNumbers().map((num, index) => (
                <button
                  key={index}
                  className={`btn ${
                    num === "..."
                      ? "btn-outline-borders bg-white text-black"
                      : page === num
                      ? "bg-black text-white"
                      : "btn-outline-borders bg-white text-black"
                  }`}
                  style={{
                    height: "32px",
                    fontSize: "14px",
                    marginRight:
                      index !== getPageNumbers().length - 1 ? "6px" : "0",
                    borderRadius: "4px",
                    padding: "0 12px",
                    fontWeight: page === num ? 600 : 400,
                    border:
                      page === num ? "1px solid black" : "1px solid #E3EBF8",
                    minWidth: "32px",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: num === "..." ? "default" : "pointer",
                    pointerEvents: num === "..." ? "none" : "auto",
                  }}
                  onClick={() => num !== "..." && setPage(num)}
                  disabled={num === "..."}
                >
                  {num}
                </button>
              ))}
            </div>

            <button
              className="btn bg-white text-black btn-outline-borders d-flex align-items-center px-2"
              style={{ height: "32px", fontSize: "14px", minWidth: "32px" }}
              onClick={() => setPage((prev) => prev + 1)}
              disabled={page === totalPages}
            >
              <FaArrowRight /> Next
            </button>

            <select
              className="form-select ms-2 bg-white text-black btn-outline-borders"
              style={{
                width: "140px",
                height: "34px",
                fontSize: "14px",
                borderRadius: "6px",
              }}
              value={limit}
              onChange={(e) => {
                setPage(1);
                setLimit(Number(e.target.value));
              }}
            >
              <option value={10}>10 per page</option>
              <option value={20}>20 per page</option>
              <option value={50}>50 per page</option>
            </select>
          </div>
        </div>

        <div>
          <ShowAdminView
            selectedView={selectedView}
            allService={allService}
            allPartner={allPartner}
            refreshPage={refreshPage}
          />
        </div>

        <Modal
          show={showAddService}
          onHide={onHideService}
          centered
          size="xl"
          backdrop="static"
          dialogClassName="custom-appointment-modal addServiceModal"
          contentClassName="rounded-4 border-0"
        >
          <Modal.Header closeButton className="border-0 pt-4 px-4">
            <Modal.Title className="w-100 fs-5 fw-bold">
              Add Service Category
            </Modal.Title>
          </Modal.Header>

          <hr className="mx-4 my-0" />

          <Modal.Body className="px-4 py-4">
            <AddService onHideService={onHideService} />
          </Modal.Body>
        </Modal>

        <Modal
          show={showProfile}
          onHide={() => setShowProfile(false)}
          centered
          size="xl"
          backdrop="static"
          dialogClassName="custom-appointment-modal addServiceModal"
          contentClassName="rounded-4 border-0"
        >
          <Modal.Header closeButton className="border-0 pt-4 px-4">
            <Modal.Title className="w-100 fs-5 fw-bold">
              Add Profile
            </Modal.Title>
          </Modal.Header>

          <hr className="mx-4 my-0" />

          <Modal.Body className="px-4 py-4">
            <div
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  // submit profile
                  addProfile();
                }
              }}
              style={{ gap: "8px" }}
              className="flex-center-col"
            >
              <input
                type="text"
                onChange={(e) => {
                  setProfile_name(e.target.value);
                  setError("");
                }}
                value={profle_name}
                className="form-control"
                placeholder="Enter Profile Name"
              />

              {error && <small className="text-danger">{error}</small>}

              <div
                onClick={addProfile}
                className="cursor-pointer rounded btn-danger p-2 px-4"
              >
                {loading ? (
                  <Loader style={{ width: 40, height: 20 }} />
                ) : (
                  "Submit"
                )}
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          show={showAddOffering}
          onHide={onHide}
          centered
          size="xl"
          backdrop="static"
          dialogClassName="custom-appointment-modal"
          contentClassName="rounded-4 border-0"
        >
          <Modal.Header closeButton className="border-0 pt-4 px-4">
            <Modal.Title className="w-100 fs-5 fw-bold">Add Type</Modal.Title>
          </Modal.Header>

          <hr className="mx-4 my-0" />

          <Modal.Body className="px-4 py-4">
            <AddOfferings
              allServices={allServices}
              partners={partners}
              data={addOffering}
              addMore={() => addMore()}
              updateData={updateData}
              removeOffering={removeOffering}
            />
          </Modal.Body>

          <hr className="mx-4 my-0" />

          <Modal.Footer className="border-0 d-flex justify-content-center gap-3 py-3">
            <Button
              variant="primary"
              className="px-4 rounded"
              onClick={addOfferingSumbit}
              // disabled={!selectedDate || !selectedTimes.length}
            >
              {loading ? (
                <Loader style={{ width: 40, height: 20 }} />
              ) : (
                "Submit"
              )}
            </Button>
            <Button
              onClick={onHide}
              variant="outline-secondary"
              className="px-4 rounded"
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={deleteModel}
          onHide={() => {
            setDeleteModel(false);
            setCurrentOffering({});
          }}
          centered
          size="xl"
          backdrop="static"
          dialogClassName="custom-appointment-modal d-flex justify-content-center addServiceModal"
          contentClassName="rounded-4 w-75 border-0"
        >
          <div>
            <div className="p-4 pb-0">
              You are about to delete the offering{" "}
              <strong>
                {curretOffering?.service_name} -{" "}
                {curretOffering?.service_type_name} -
                {curretOffering?.service_offering_name}
              </strong>
              . This action cannot be undone. Are you sure you want to proceed?
            </div>
            <div className="d-flex justify-content-center mt-2 mb-4">
              <button
                type="button"
                className="btn Button primaryColorText btn-outline-secondary me-2 no-hover-effect mt-4"
                onClick={() => {
                  setDeleteModel(false);
                  setCurrentOffering({});
                }}
              >
                Cancel
              </button>
              <button
                onClick={() => deleteOffering()}
                type="submit"
                className="btn Button primaryBackground text-white position-relative d-flex justify-content-center align-items-center mt-4"
              >
                {loading ? (
                  <Loader style={{ width: 40, height: 20 }} />
                ) : (
                  "Delete"
                )}
              </button>
            </div>
          </div>
        </Modal>

        <Modal
          show={updateModel}
          onHide={() => {
            setUpdateModel(false);
            setCurrentOffering({});
          }}
          centered
          size="xl"
          backdrop="static"
          dialogClassName="custom-appointment-modal"
          contentClassName="rounded-4  border-0"
        >
          <Modal.Header closeButton className="border-0 pt-4 px-4">
            <Modal.Title className="w-100 fs-5 fw-bold">
              Update Type
            </Modal.Title>
          </Modal.Header>

          <div className="px-4">
            <EachAddOffering
              allServices={allServices}
              partners={partners}
              updateOfferingData={updateOfferingData}
              isUpdate={true}
              data={curretOffering}
              removeOffering={removeOffering}
            />

            <div className="d-flex justify-content-center mt-2 mb-4">
              <button
                type="button"
                className="btn Button primaryColorText btn-outline-secondary me-2 no-hover-effect mt-4"
                onClick={() => {
                  setUpdateModel(false);
                  setCurrentOffering({});
                }}
              >
                Cancel
              </button>
              <button
                onClick={() => updateOffering()}
                type="submit"
                className="btn Button primaryBackground text-white position-relative d-flex justify-content-center align-items-center mt-4"
              >
                {loading ? (
                  <Loader style={{ width: 40, height: 20 }} />
                ) : (
                  "Update"
                )}
              </button>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
}

export default AdminSetup;
